import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import DatePicker from 'components/DatePicker';
import StyledSelect from 'components/StyledSelect';
import { EditableTableRow, EditableTableCell } from 'components/EditableTable';
import ReactSelect from 'components/StyledSelect/react_select';
import reactSelectStyles from 'components/ReactSelect/styles';
import { isEqual, isEmpty } from 'lodash';
import S from '../styles.scss';

const DATE_FORMAT = 'MM/DD/YYYY';
const BLANK_ERROR = 'Can\'t be blank';

class TravelingWorkTableRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.mapTWD(this.props.twd);
  }

  componentWillReceiveProps = (nextProps) => {
    const { twd } = nextProps;
    if (twd.id !== 'new' && isEqual(twd, this.props.twd)) return;
    this.setState(this.mapTWD(twd));
  }

  mapTWD = (twd) => {
    const startDate = twd.start_date && moment(twd.start_date).format(DATE_FORMAT);
    const endDate = twd.end_date && moment(twd.end_date).format(DATE_FORMAT);
    const crew = (twd.assignee || {}).id || '';
    return { errors: {}, ...twd, start_date: startDate, end_date: endDate, crew };
  }

  validate = () => {
    const { crew, traveling_stores, start_date, end_date } = this.state;
    const errors = {};
    if (!crew) errors.crew = BLANK_ERROR;
    if (!traveling_stores ||
      traveling_stores.length < 1) errors.traveling_store = BLANK_ERROR;
    if (!start_date) errors.start_date = BLANK_ERROR;
    if (!end_date) errors.end_date = BLANK_ERROR;
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleChange = attr => (val) => {
    if (attr === 'traveling_stores') {
      const storeIDs = val.map(store => store.value);
      this.setState({ [attr]: storeIDs });
    } else {
      this.setState({ [attr]: val.target ? val.target.value : val });
    }
  }

  handleSave = () => this.validate() && this.props.onSave(this.state);

  handleDelete = () => this.props.onDelete(this.state);

  handleCrewChange = this.handleChange('crew');
  handleStartDateChange = this.handleChange('start_date');
  handleEndDateChange = this.handleChange('end_date');
  handleTravelingStoresChange = this.handleChange('traveling_stores');

  renderCrewCell = () => {
    const { assignee = {}, errors } = this.state;
    const { crews, isCrew } = this.props;
    const options = crews.map(crew => ({ label: crew.name, value: crew.id }));
    const value = (assignee || {}).name;
    const error = errors.crew;
    const cellProps = {
      label: 'Crew',
      display: isCrew,
      onChange: this.handleCrewChange,
      value,
      error,
      cellReadOnly: !isEmpty(assignee),
    };
    return (<EditableTableCell {...cellProps}>
      <StyledSelect options={options} value={this.state.crew} className={S.select} placeholder=" " />
    </EditableTableCell>);
  }

  renderDateCell = (attr, label) => {
    const { twd } = this.props;
    const { errors } = this.state;
    const value = twd[attr] && moment(twd[attr]).format(DATE_FORMAT);
    const minDate = moment().subtract(1, 'day').toDate();
    return (<EditableTableCell
      label={label}
      value={value}
      onChange={attr === 'start_date' ? this.handleStartDateChange : this.handleEndDateChange}
      error={errors[attr]}
    >
      <DatePicker value={this.state[attr]} minDate={minDate} className={S.datepicker} />
    </EditableTableCell>);
  }

  renderTravelingStoresCell = (label) => {
    const { storeOptions } = this.props;
    const { traveling_stores, errors } = this.state;
    const sortedStoreOptions = storeOptions.slice().sort((a, b) => {
      if (b.label < a.label) return 1;
      return -1;
    });
    const storeNames = [];
    (Object.values(storeOptions) || []).forEach((store) => {
      if (traveling_stores.includes(store.value)) storeNames.push(store.label);
    });
    return (<EditableTableCell
      label={label}
      value={storeNames.join(', ') || ''}
      onChange={this.handleTravelingStoresChange}
      error={errors.traveling_store}
    >
      <ReactSelect
        multi
        name="TravelingStores"
        className={reactSelectStyles.selectWrapper}
        options={sortedStoreOptions}
        value={traveling_stores}
        placeholder="Select store(s)"
      />
    </EditableTableCell>);
  }

  render = () => {
    const isNew = this.state.id === 'new';
    const disabled = moment().isAfter(moment(this.state.end_date, DATE_FORMAT), 'day');
    const rowProps = { isNew, disabled, onSave: this.handleSave, onDelete: this.handleDelete };
    return (<EditableTableRow className={this.props.className} {...rowProps}>
      {this.renderCrewCell()}
      {this.renderDateCell('start_date', 'Start Date')}
      {this.renderDateCell('end_date', 'End Date')}
      {this.renderTravelingStoresCell('Traveling Stores')}
    </EditableTableRow>);
  }
}

TravelingWorkTableRow.contextTypes = {
  isEditable: PropTypes.bool,
};

TravelingWorkTableRow.propTypes = {
  twd: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  crews: PropTypes.array,
  isCrew: PropTypes.bool,
  storeOptions: PropTypes.array,
  className: PropTypes.string,
};

TravelingWorkTableRow.defaultProps = {
  crews: [],
  isCrew: false,
  className: '',
};

export default TravelingWorkTableRow;



// WEBPACK FOOTER //
// ./client/app/shared/components/TravelingWorkTable/components/travelingWorkTableRow.jsx